import { spacing, color } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-asset-gif";
const toggle = objectWithClassName({
  className: `${classNamePrefix}-toggle`,
  display: "block",
  height: "100%",
  width: "100%",
  ["& canvas, & img"]: {
    display: "block",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    objectFit: "cover",
    objectPosition: "center",
    transform: "scale(1)",
    transition: "transform 0.5s ease-in-out"
  },
  ["& canvas"]: {
    opacity: "0",
    objectFit: "cover"
  },
  ["& button"]: {
    position: "absolute",
    top: "0",
    right: "0",
    width: "44px",
    height: "44px",
    backgroundColor: `rgba(0, 0, 0, 0.8)`,
    zIndex: "99",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ["& svg"]: {
      fill: `${color.white}`,
      width: `${spacing.md}`
    }
  }
});
export {
  toggle
};
//# sourceMappingURL=gif.js.map
